import { createFileRoute } from '@tanstack/react-router'
import InventoryDetailView from './-components/inventory-detail-view.tsx'

export const Route = createFileRoute('/manager/_layout/inventory/$itemId')({
  component: Component,
})

function Component() {
  const { itemId } = Route.useParams()
  
  return <InventoryDetailView itemId={itemId} />
}
